import React from 'react';

const Version = () => {
  return <div>{`${process.env.REACT_APP_NAME}:${process.env.REACT_APP_VERSION}`}</div>;
};

export default Version;
